import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldComponent, FieldSet} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-render-schema'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {$} from '@/facade'
import RenderColor from '@/components/render/RenderColor.vue'

export class ListGithubRepositorySchema extends DefaultSchema {
  readonly name = 'ListGithubRepository'

  readonly fieldSet: FieldSet<GithubRepository> = {
    githubOrganization: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.githubOrganization?.name,
      },
    }),
    name: (): FieldComponent => ({
      is: Component.Render,
    }),
    colorHex: (): FieldComponent => ({
      is: RenderColor,
    }),
    url: (): FieldComponent => ({
      is: Component.Render,
    }),
    labelsTokenized: (): FieldComponent => ({
      is: Component.Render,
    }),
    description: (): FieldComponent => ({
      is: Component.Render,
    }),
    branch: (): FieldComponent => ({
      is: Component.Render,
    }),
    createdAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.createdAt),
      },
    }),
    updatedAt: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: $.filter.datetime(schema.model.updatedAt),
      },
    }),
  }
}
